<template>
    <span>
        <v-btn text :disabled="disabled || saving" :loading="saving" @click="open">{{ snoozedUntil ? 'Gestisci rinvio' : 'Ricordamelo' }}</v-btn>
        <v-dialog :value="visible" :persistent="saving" max-width="480" :fullscreen="$vuetify.breakpoint.xsOnly" @input="!$event && close()">
            <div class="mc-root notification-rule-dialog" role="dialog" aria-modal="true" :aria-labelledby="titleId">
                <h2 :id="titleId" class="t-title-2">Ricordamelo più tardi</h2>
                <p>Il rinvio vale solo per te e per tutte le attività di questa notifica. Il lavoro resta aperto; nuove attività o solleciti possono riattivare l’avviso.</p>
                <p v-if="snoozedUntil">Rinviato al {{ updatedAt(snoozedUntil) }}.</p>
                <v-radio-group v-model="choice" :disabled="saving" aria-label="Quando ricordare">
                    <v-radio label="Tra un’ora" value="hour" /><v-radio label="Domani alle 09:00" value="tomorrow" /><v-radio label="Scegli data e ora" value="custom" />
                </v-radio-group>
                <v-text-field v-if="choice === 'custom'" v-model="custom" type="datetime-local" outlined dense label="Data e ora del promemoria" :disabled="saving" hint="Entro sette giorni, nell’ora locale del dispositivo." persistent-hint />
                <p v-if="error" class="notification-rules__warning" role="alert">{{ error }}</p>
                <footer class="notification-rules__actions"><v-btn text :disabled="saving" @click="close">Annulla</v-btn><v-btn v-if="snoozedUntil" outlined :disabled="saving" @click="save(null)">Riattiva ora</v-btn><v-btn depressed color="primary" :loading="saving" @click="confirm">Conferma rinvio</v-btn></footer>
            </div>
        </v-dialog>
    </span>
</template>
<script>
import { updatedAt } from '../../assets/mecom/js/format.mjs';
import { reminderDate, validReminder } from './activities/helpers.mjs';
import { checkedData, errorText } from './admin/rules.mjs';
import './admin/rules.css';
export default {
    name: 'ReminderControl', props: { id: Number, revision: Number, snoozedUntil: String, disabled: Boolean },
    data: () => ({ titleId: `reminder-title-${crypto.randomUUID()}`, visible: false, saving: false, choice: 'hour', custom: '', error: '', disposed: false }),
    computed: { epoch() { return this.$store.state.notifications.epoch; } },
    watch: { epoch() { this.visible = false; this.error = ''; } },
    beforeDestroy() { this.disposed = true; },
    methods: {
        updatedAt,
        open(event) { this.opener = event.currentTarget; this.error = ''; this.visible = true; },
        close() { this.visible = false; this.$nextTick(() => { if (this.opener?.isConnected) this.opener.focus(); }); },
        confirm() { const until = reminderDate(this.choice, this.custom); if (!validReminder(until)) { this.error = 'Scegli una data futura entro sette giorni.'; return; } this.save(until); },
        async save(until) {
            if (this.saving) return;
            const epoch = this.epoch; this.saving = true; this.error = '';
            try {
                checkedData(await this.$work.post(`/notifiche/${this.id}/promemoria/`, { revision: this.revision, until }, true));
                if (this.disposed || epoch !== this.epoch) return;
                this.close(); this.$emit('changed'); this.$store.dispatch('notifications/load', { work: this.$work });
            } catch (error) { if (!this.disposed && epoch === this.epoch) this.error = errorText(error); }
            finally { this.saving = false; }
        },
    },
};
</script>
